<template>
  <transition enter-active-class="duration-300" leave-active-class="duration-200">
    <div v-show="reviewModalOpen" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <transition
        enter-active-class="duration-300 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div v-show="reviewModalOpen" class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
      </transition>
      <div class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
          <transition
            enter-active-class="duration-300 ease-out"
            enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-from-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div v-show="reviewModalOpen" class="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
              <div>
                <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                  <div slot="reference" class="text-green-500">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"></path></svg>
                  </div>
                </div>
                <div class="mt-3 sm:mt-5">
                  <div class="text-center">
                    <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">Request A Document Review</h3>
                    <div class="mt-2">
                      <p class="text-gray-500">Send an action item to the nominated staff member before requesting signing or approval from the client.</p>
                    </div>
                  </div>
                  <div class="mt-4">
                    <label class="label">Reviewer<sup>*</sup></label>
                    <select :value="reviewUserId" @change="e => updateReviewUserId(e.target.value)" class="input full sm:text-sm sm:leading-5 form-select">
                      <option :value="null">Nominate reviewer</option>
                      <option v-for="user in staffUsers" :key="user.id" :value="user.id">{{ user.name }}</option>
                    </select>
                  </div>
                  <div class="mt-4">
                    <label class="label">Note</label>
                    <textarea :value="reviewContext" @input="e => updateReviewContext(e.target.value)" class="input full sm:text-sm sm:leading-5" rows="3" placeholder="Optionally add a note to the reviewer relating to this request"></textarea>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button v-if="reviewLoading" disabled type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-brand-light text-base font-medium text-white hover:bg-brand-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-dark sm:col-start-2 sm:text-sm">Sending...</button>
                <button v-else-if="reviewCompleted" disabled type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-500 text-base font-medium text-white hover:bg-brand-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-dark sm:col-start-2 sm:text-sm">Request Sent!</button>
                <button v-else @click="triggerReviewRequest" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-brand-dark text-base font-medium text-white hover:bg-brand-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-dark sm:col-start-2 sm:text-sm">Send Request</button>
                <button @click="closeReviewModal" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-dark sm:mt-0 sm:col-start-1 sm:text-sm">Cancel</button>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  computed: {
    ...mapState([
      'reviewModalOpen',
      'staffUsers',
      'reviewLoading',
      'reviewCompleted',
      'reviewUserId',
      'reviewContext'
    ])
  },
  methods: {
    ...mapMutations([
      'closeReviewModal',
      'updateReviewUserId',
      'updateReviewContext'
    ]),
    ...mapActions([
      'requestReview'
    ]),
    triggerReviewRequest() {
      this.requestReview({ context: this.context });
    }
  }
}
</script>
